/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CustomTitle, TeamDetailsStyledModal, UpdateTeamButton, AddMemberButton, CustomDropdownMenue, CustomDropdownMenuItem, TeamCardV2, MemberDataV2, CustomRadioButton, SelectImage, InputImage, CaptainLogo, Title, MemberWrap, MemberCard } from './styles';
import { Modal } from 'react-bootstrap';
import { checkImage, getOrientation, resetOrientation } from '../../utils/methods';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { fetchAddOrUpdateTeamDetails, fetchUsersToAddToTeam } from '../../redux/actions';
import { ImageUrl } from '../../utils/constants';
import {CloseIconBranding, closeIcon, UploadHDMIcon, VerticalDotsIcon, Captain} from '../../utils/icons'
import LazyImage from '../common/LazyImage/LazyImage';
import {HeaderPopup} from '../HealthDataManagement/styles'
import { TextAreaWrapperSearchPopup, SelectedUserWrapper } from '../ChallengeDetailsV2/styles';
import {RadioButtonWrapper, RadioButton} from '../RecogntionAdmin/styles'
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import { withTranslation } from "react-i18next";
import { StyledModal } from '../PeopleHomeV2/ManageBuddies/styles';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import {DownAngleV2} from '../SocialFeedsV2/styles'
import {CommonButton} from '../common/commonStyles'
import { NameInitials } from "../Manager/styles";
import { getInitials } from "../../utils/methods";

class TeamDetailsPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      peopleTeams:props.peopleTeams,
      addButtondisabled: true,
      radio: "upload",
      teamName: props.defaultTeamName,
      teamId: null,
      teamLogo: null,
      teamUsers: [],
      teamDetailsData: [],
      captainUID: null,
      teamIcons: [],
      imageUpdated: 0,
      default_icon: 1,
      defaultLogo: null, showModal: false
    };
  }

  componentDidMount() {
    const { teamDetailsData, teamIcons, defaultTeamName } = this.props
    if (teamDetailsData[0]) this.setState({
      teamName: teamDetailsData[0].name != null ? teamDetailsData[0].name : defaultTeamName,
      teamUsers: teamDetailsData[0].team_users != null ? teamDetailsData[0].team_users : [],
      teamLogo: teamDetailsData[0].logo != null ? `${ImageUrl}/${teamDetailsData[0].logo}` : "",
      defaultLogo: teamDetailsData[0].logo != null ? teamDetailsData[0].logo : "",
      teamId: teamDetailsData[0].id != null ? teamDetailsData[0].id : null,
      teamDetailsData: teamDetailsData
    })
    if (teamIcons) {
      this.setState({ teamIcons: teamIcons })
    }
  }

  componentDidUpdate(prevProps) {
    const { teamDetailsData, teamIcons, defaultTeamName } = this.props
    if (this.state.teamIcons != this.props.teamIcons) {
      if (teamIcons) {
        this.setState({ teamIcons: teamIcons })
      }
    }

    if (this.state.teamDetailsData != this.props.teamDetailsData) {
      if (teamDetailsData[0]) this.setState({
        teamName: teamDetailsData[0].name != null ? teamDetailsData[0].name : defaultTeamName,
        teamUsers: teamDetailsData[0].team_users != null ? teamDetailsData[0].team_users : [],
        defaultLogo: teamDetailsData[0].logo != null ? teamDetailsData[0].logo : "",
        teamLogo: teamDetailsData[0].logo != null ? `${ImageUrl}/${teamDetailsData[0].logo}` : "",
        teamId: teamDetailsData[0].id != null ? teamDetailsData[0].id : null,
        teamDetailsData: teamDetailsData
      })
    }
  }

  onChangeImg = (baseImage) => {
    // let file = e?.target?.files?.[0] || e?.target?.files;
    // if (checkImage(e?.target?.files)) {
    //   if ((file?.size / 1000000) <= 20) {
    //     let reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //       this.setState({
    //         teamLogo: reader.result,
    //         imageUpdated: 1,
    //         default_icon: 0
    //       });
    //       getOrientation(file, (or) => {
    //         resetOrientation([reader.result], or, (baseImage) => {
    //           this.setState({
    //             teamLogo: baseImage,
    //             imageUpdated: 1,
    //             default_icon: 0
    //           });
    //         });
    //       });
    //     };
    //   } else {
    //     toast.error('Please select image file less than 20MB');
    //     document.getElementById('profle-file').value = '';
    //   }
    // } else {
    //   toast.error("image Error Message");
    //   document.getElementById('profle-file').value = '';
    // }
    this.setState({
      teamLogo: baseImage,
      imageUpdated: 1,
      default_icon: 0
    });
  };

  handleAddModal = () => {
    const { hideModal, showAddModal, companyId, fetchUsersToAddToTeam, teamDetailsData } = this.props;
    const {teamId} = this.state;
    let obj = {};
    let teamUserCount=teamDetailsData[0].team_users.length;
    let teamCountLimit=teamDetailsData[0].count;
    obj['company_id'] = companyId;
    // hideModal();
    showAddModal(teamId, teamCountLimit, teamUserCount);
    fetchUsersToAddToTeam(obj);
  }

  handleMakeCaptain = (uid) => {
    const { teamUsers } = this.state;
    let allUsers = teamUsers;
    teamUsers.map((user, index) => {
      if (user.uid == uid) {
        if (allUsers[index].is_captain) {
          allUsers[index].is_captain = 0;
        }
        else { allUsers[index].is_captain = 1; }
      }
      else { allUsers[index].is_captain = 0; }
    })
    this.setState({
      teamUsers: allUsers
    })
  }

  submitTeamDetails = () => {
    const { teamId, teamName, teamLogo, defaultLogo, teamUsers, imageUpdated, default_icon } = this.state;
    const { fetchAddOrUpdateTeamDetails, hideModal, companyId, limit, pageNo } = this.props;
    let teamDetails = {};
    teamDetails['team_id'] = teamId;
    teamDetails['team_name'] = teamName;
    teamDetails['team_logo'] = default_icon ? defaultLogo : teamLogo;
    teamDetails['team_users'] = teamUsers;
    teamDetails['imageUpdated'] = imageUpdated;
    teamDetails['default_icon'] = default_icon;
    fetchAddOrUpdateTeamDetails(teamDetails, companyId, pageNo, limit, teamId);
    hideModal();
  }

  submitTeamDetailsForRemoveUsers = () => {
    const { teamId, teamName, teamLogo, defaultLogo, teamUsers, imageUpdated, default_icon } = this.state;
    const { fetchAddOrUpdateTeamDetails, companyId, limit, pageNo } = this.props;
    let teamDetails = {};
    teamDetails['team_id'] = teamId;
    teamDetails['team_name'] = teamName;
    teamDetails['team_logo'] = default_icon ? defaultLogo : teamLogo;
    teamDetails['team_users'] = teamUsers;
    teamDetails['imageUpdated'] = imageUpdated;
    teamDetails['default_icon'] = default_icon;
    fetchAddOrUpdateTeamDetails(teamDetails, companyId, pageNo, limit, teamId);
  }

  handleRemove = (uid) => {
    let updatedUsers = this.state.teamUsers.filter((obj) => obj.uid != uid);
    this.setState({
      teamUsers: updatedUsers
    }, () => {
      // this.submitTeamDetailsForRemoveUsers();
    })
  }

  hideTeamPopup = () => {
    this.setState({
      radio: null
    }, () => {
      this.props.hideModal();
    })
  }

  fallBack = (e) => {
    e.target.src = '/public/images/default.png'
  }

  render() {
    const { showModal, hideModal, teamDetailsData, teamIcons, peopleTeams, /*maxTeamMemeberCount*/ t} = this.props;
    const { teamName, teamUsers, teamLogo } = this.state;
    return (
      <StyledModal
        show={showModal}
        onHide={hideModal}
        removeButton={teamLogo != null}
        width={"450px"}
        paddingV='0px'
        padding="0px"
        heightV="530px"
        scroll
        height="auto"
      >
        <HeaderPopup >
          <div className="title">Team Details</div>
          <div className="closeIcon" onClick={() => this.hideTeamPopup()}>
            {CloseIconBranding()}
          </div>
        </HeaderPopup>
        <div style={{width:"100%", height:"1px", background:"#EFEFEF"}}></div>
        <Modal.Body>
          <div className="teamWrapper">
            <Title>Your team name<span className='red'>*</span></Title>
            <div className='teamNameDiv'>
              <TextAreaWrapperSearchPopup margin="0">
                <SelectedUserWrapper width={"100%"} inputHeight={"24px"}>
                  <textarea
                    value={teamName}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      if (newValue.length <= 50) {
                        this.setState({ teamName: newValue });
                      }
                    }}
                  />
                </SelectedUserWrapper>
              </TextAreaWrapperSearchPopup>
              <div className='count'>{teamName?.length}/50 | C</div>
            </div>
            <div className='teamLogoDiv'>
              <Title>Your Team Logo</Title>
              <div className='radioButtonDiv'>
                <RadioButtonWrapper gap>
                  <div className="RadioButtonContainer " onClick={() => this.setState({ radio: this.state.radio == "upload" ? null : "upload" })}>
                    <RadioButton
                      type="radio"
                      name="option"
                      checked={this.state.radio == "upload"}
                      handler={this.toggleRadioButton}
                      id="1"
                    />
                    <div className="label">Upload</div>
                  </div> 
                  <div className="RadioButtonContainer " onClick={() => this.setState({ radio: this.state.radio == "selected" ? null : "selected" })} style={{marginLeft:"20px"}}>
                    <RadioButton
                      type="radio"
                      name="option"
                      checked={this.state.radio == "selected"}
                      handler={this.toggleRadioButton}
                      id="2"
                    />
                    <div className="label">Select from lists</div>
                  </div>
                </RadioButtonWrapper>

              </div>
              {this.state.radio ? this.state.radio == "upload" ? 
                <CommonImageUploader
                  imgSrc={this.state.teamLogo}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChangeImg}
                  accept=".jpeg, .png, .jpg"
                  ImageType="(.png, .jpg)(up to 2 MB)"
                  label="Upload Team Logo"
                  maxSizeMB={2}
                  onRemoveImage={() => this.setState({ teamLogo: null,default_icon:1,defaultLogo:"images/PeoplePage/teams-logo.svg" })}
                /> 
                : <div className='selectedDiv' style={{width:"100%", display:"flex", gap:"12px 20px", flexWrap:"wrap", marginTop:"12px"}}>
                  {teamIcons?.length > 0 ? teamIcons?.map((img, index) => <SelectImage key={index} onClick={() => this.setState({ teamLogo: this.state.teamLogo == `${ImageUrl}/${img.icon}` ? null : `${ImageUrl}/${img.icon}`, defaultLogo: img.icon })}>
                    <img src={img.icon ? `${ImageUrl}/${img.icon}` : '/public/images/grid.png'} style={{ border: `${ImageUrl}/${img.icon}` == teamLogo && " 2px solid #F37A65" }} ></img>
                  </SelectImage>) : null}
                </div> : null}
            </div>
            <TeamCardV2>
              <MemberWrap height={"288px"} scroll>
                <div className='title'>
                  <div className='mem'>{teamUsers.length} team members</div>
                  <div className='add' onClick={() => this.handleAddModal()}></div>
                </div>
                <div className='wrap'>
                  {teamDetailsData && teamDetailsData.length?
                    teamUsers?.map((member,index)=>

                      <MemberCard key={index}>
                        {member?.profile_image !== "profile-Image/default.png"? <div className='icon'>
                          <img src={`${ImageUrl}/${member?.profile_image}`} />
                        </div>:<NameInitials>{getInitials(member?.fullname)}</NameInitials>}
                        <div className='name'>
                          {member.fullname}<span>{member.is_captain?"(Captain)":null}</span>{member.is_champion? Captain():null}
                        </div>
                        <div className='menu'>
                          <DownAngleV2  feed>
                            <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>}>
                              <Dropdown.Item onClick={() => this.handleMakeCaptain(member.uid)}>
                                {member.is_captain ? "Remove Captain" : " Make Captain"}
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => this.handleRemove(member.uid)}>
                                {("Remove")}
                              </Dropdown.Item>
                            </DropdownButton>
                          </DownAngleV2>
                        </div>
                      </MemberCard>)
                    :null
                  }
                </div>
                <div className='button-wrap'>
                  <CommonButton disabled={teamName.length === 0}  onClick={() => this.submitTeamDetails()}>Save The Update</CommonButton>
                </div>
              </MemberWrap>
            </TeamCardV2>
          </div>
        </Modal.Body>
      </StyledModal>
    )
  }
}

TeamDetailsPopup.propTypes = {
  history: PropTypes.object.isRequired,
  showModal: PropTypes.bool,
  hideModal: PropTypes.func,
  fetchAddOrUpdateTeamDetails: PropTypes.func,
  teamDetailsData: PropTypes.array,
  teamIcons: PropTypes.array,
  showAddModal: PropTypes.func,
  defaultTeamName: PropTypes.string,
  peopleTeams: PropTypes.bool,
  companyId: PropTypes.number,
  pageNo: PropTypes.number,
  limit: PropTypes.number,
  fetchUsersToAddToTeam: PropTypes.func,
  maxTeamMemeberCount: PropTypes.number,
  t: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
  fetchAddOrUpdateTeamDetails: (object, companyId, pageNo, limit, teamId) => dispatch(fetchAddOrUpdateTeamDetails(object, companyId, pageNo, limit, teamId)),
  fetchUsersToAddToTeam: (object) => dispatch(fetchUsersToAddToTeam(object))
});

export default connect(null, mapDispatchToProps) (withTranslation()(TeamDetailsPopup));
